import React, { useState } from "react"; // ✅ this imports useState
import MainTitle from "../../muiHome/mainTitle";
import {
  Card,
  Grid,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography, // ✅ this fixes Typography error
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const CourtVisitReport = () => {
  const [openImg, setOpenImg] = useState(false);
  const [previewImg, setPreviewImg] = useState('');

  const handleImgPreview = (img) => {
    setOpenImg(true);
    setPreviewImg(img);
  };

 const items = [
  { img: "/assets/img/SOL/event/event1_mg35.jpg" },
  { img: "/assets/img/SOL/event/event1_mg36.jpg" },
  { img: "/assets/img/SOL/event/event1_mg37.jpg" }, 
  { img: "/assets/img/SOL/event/event1_mg38.jpg" }, 
  { img: "/assets/img/SOL/event/event1_mg39.jpg" },  
  
];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MainTitle title="Court Visit Report" />
      </Grid>

      <Grid item xs={12}>
        <Typography fontSize="14px" fontFamily="sans-serif">
            <p> Organized by: School of Law, MVN University, Palwal </p>
           <p>Venue: District Court, Palwal  </p>
            <p> Objective of the Court Visit: </p>
           
           <ul>
              <li> Provide law students with practical exposure to the judicial system</li>
              <li> 	Familiarize students with the working environment of courts, legal procedures, and the roles of legal professionals.

</li>
              <li> Enhance their understanding of courtroom etiquette, case flow, and practical application of legal knowledge.</li>
              <li> 	Bridge the gap between theory and practice in legal education.</li>
             
           </ul>
      
        </Typography>
      </Grid>

      {items.map((item, index) => (
  <Grid item xs={3} textAlign="center" key={index}>
    <Card
      sx={{
        height: "300px",
        padding: "10px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onClick={() => handleImgPreview(item.img)}
    >
      <CardMedia
        component="img"
        height="100%"
        image={item.img}
        alt="Event"
        style={{ height: "100%", width: "100%", objectFit: "contain" }}
      />
    </Card>
  </Grid>
))}

      <Dialog open={openImg} onClose={() => setOpenImg(false)}>
        <DialogTitle>
          <IconButton
            edge="end"
            onClick={() => setOpenImg(false)}
            aria-label="close"
            sx={{
              position: 'absolute',
              color: '#000',
              top: 0,
              right: 25
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img src={previewImg} height="100%" width="auto" alt="Preview" />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default CourtVisitReport;
